/**
 * Create instance of AFClub.
 *
 * @constructor
 * @this AFClub
 * @param {Object} Club data already prepared for Front-end.
 */
function AFClub(data) {

	// For supports all fields get from Back-end.
	// Different API calls return different fields for clubs.
	// @TODO delete it after copying all the fields here
	for (let key in data) {
		this[key] = data[key]
	}

	/**
	 * @type {string}
	 */
	this.id = data.id.toString();


}


/**
 * Returns Visit Gym URL.
 *
 * @this AFClub
 * @return {string} International domain URL.
 */
AFClub.prototype.getVisitGymUrl = function() {
	let result;
	if ( this.isLocalClub ) {
		result = this.url;
	} else {
		// use only domain
		let a = document.createElement( "a" );
		a.href = this.url;
		result = a.origin;
	}
	return result;
};


/**
 * Returns Try Us Free Url.
 *
 * @this AFClub
 * @return {string} International domain URL.
 */
AFClub.prototype.getTryUsFreeUrl = function() {
	let result;
	if ( this.isLocalClub ) {
		if ( this.club.passCustom ) {
			result = this.club.passUrl;
		} else {
			result = this.club.url;
		}
	} else {
		// use only domain
		let a = document.createElement( "a" );
		a.href = this.url;
		result = a.origin;
	}
	return result;
};

